import React from "react";
import { Route } from "react-router-dom";
import { ProtectedRoute } from "../hooks/rute/ProtectedRoute";
import { ProtectedRoleTecnical } from "../hooks/roles/ProtectedRoleTecnical";
import { LazySuspense } from "../components/layout/AppHeader/lazySuspense";
const ErrorPage = React.lazy(() => import("../components/error-page"));
const GuardiasTecnico = React.lazy(
  () => import("../screean/task/guardiasTecnico")
);

export function guardiaTecnico() {
  return (
    <Route
      path="/guardia-tecnico"
      element={
        <LazySuspense>
          {" "}
          <ProtectedRoute>
            <ProtectedRoleTecnical>
              <LazySuspense>
                <GuardiasTecnico />
              </LazySuspense>
            </ProtectedRoleTecnical>
          </ProtectedRoute>
        </LazySuspense>
      }
      errorElement={
        <LazySuspense>
          <ErrorPage />
        </LazySuspense>
      }
    />
  );
}
